import { render } from "./CopyIcon.vue?vue&type=template&id=067ee1ae&scoped=true"
import script from "./CopyIcon.vue?vue&type=script&lang=js"
export * from "./CopyIcon.vue?vue&type=script&lang=js"

import "./CopyIcon.vue?vue&type=style&index=0&id=067ee1ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-067ee1ae"

export default script